import { useQuery } from 'react-query';
import { getPhysicians, getShippingLocations } from '@/services/contactsAccounts';

export const useGetPhysicians = ({
	clinic_id,
	page = 1,
	limit = 50,
	search = '',
	sort = '',
	enabled = true,
}: {
	clinic_id?: string;
	page?: number;
	limit?: number;
	search?: string;
	sort?: string;
	enabled?: boolean;
}) => {
	return useQuery({
		queryKey: ['physicians', clinic_id, page, limit, search, sort],
		queryFn: () => getPhysicians(clinic_id, page, limit, search, sort),
		enabled,
		keepPreviousData: false,
		// staleTime: , // 5 minutes
		// cacheTime: 10 * 60 * 1000, // 10 minutes
	});
};

export const useGetShippingLocations = ({
	account_id,
	page = 1,
	limit = 50,
	search = '',
	sort = '',
	enabled = true,
}: {
	account_id?: string;
	page?: number;
	limit?: number;
	search?: string;
	sort?: string;
	enabled?: boolean;
}) => {
	return useQuery({
		queryKey: ['shippingLocations', account_id, page, limit, search, sort],
		queryFn: () => getShippingLocations(account_id, page, limit, search, sort),
		enabled: enabled && !!account_id,
		keepPreviousData: true,
		staleTime: 5 * 60 * 1000, // 5 minutes
		cacheTime: 10 * 60 * 1000, // 10 minutes
	});
};
